// App
export const NOTES = 'notes'
export const MESSAGES = 'messages'



// WEBPACK FOOTER //
// ./client/firebase-setup/ref-types.js